import styled from 'styled-components';
import {device} from 'styled/device';

export const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 80px;

  @media (max-width: ${device.mobileM}) {
    padding: 0 20px;
  }
`;

export const BackButtonMenu = styled.div`
  .backButtonMenuTitle {
    display: none;
  }

  .mobileBackButton {
    display: none;
  }

  @media (max-width: ${device.mobileM}) {
    display: flex;
    margin-left: 0;
    width: 100%;
    align-items: center;
    height: 95px;

    .desktopBackButton {
      display: none;
    }

    .mobileBackButton {
      display: flex;
      flex-direction: center;
      align-items: center;
      width: 30px;
      height: 100%;
      cursor: pointer;
    }

    .backButtonMenuTitle {
      display: flex;
      justify-content: center;
      flex-grow: 1;
      font-size: 21px;
      font-weight: 500;
    }
  }
`;

export const HeaderEditGuest = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;

  @media (max-width: ${device.mobileM}) {
    flex-direction: column;
    justify-content: center;

    .saveButtonHeader {
      display: none;
    }
  }
`;

export const HeaderEditGuest2 = styled.div`
  font-size: 22px;
  color: #23262f;
  font-weight: 600;
  padding: 50px 0 30px 0;

  @media (max-width: ${device.mobileM}) {
    font-size: 21px;
    font-weight: 500;
    padding: 30px 0 30px 0;
  }
`;

export const StyledForm = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  justify-content: space-between;
  height: 100%;

  @media (max-width: ${device.mobileM}) {
    gap: unset;
  }
`;

export const Row = styled.div<{isHeaderMenu?: boolean}>`
  display: flex;
  width: 100%;
  gap: 40px;
  ${({isHeaderMenu}) => (isHeaderMenu ? ` padding-top: 30px;` : '')}

  img {
    /* border: 1px solid #b1b5c3; */
    border-radius: 7px;
  }

  &.photoHeader {
    justify-content: space-between;
    padding-bottom: 20px;
    align-items: center;
  }

  .photoSide {
    font-size: 16px;
    font-weight: 500;
    text-transform: capitalize;
  }

  .photoConnected {
    font-size: 14px;
    color: #777e90;
  }

  .updateDocument {
    display: none;
  }

  @media (max-width: ${device.mobileXL}) {
    flex-direction: column;
    gap: unset;
    align-items: center;

    padding-top: 0;

    &.photoHeader {
      row-gap: 20px;
      align-items: center;
    }

    .photoSide {
      font-size: 18px;
      padding: 0;
      align-items: center;
    }

    .photoConnected {
      display: none;
      align-items: center;
    }

    .updateDocument {
      display: flex;
    }

    .saveChangesBottomButton {
      align-items: center;
    }
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${device.mobileXL}) {
    width: 100%;

    .retakeButton {
      align-items: center;
    }
  }
`;

export const BackButton = styled.div`
  cursor: pointer;
`;

export const GuestName = styled.div`
  font-size: 30px;
  letter-spacing: 0.3;

  @media (max-width: ${device.mobileM}) {
    font-size: 24px;
  }
`;

export const Signature = styled.div`
  font-size: 30px;
  background-color: white;
  border: 1px solid #b1b5c3;
  border-radius: 25px;
  padding: 10px 20px 40px 20px;

  img {
    border: 1px solid #b1b5c3;
    border-radius: 7px;
    min-width: 320px;
    width: 100%;
  }

  @media (max-width: ${device.mobileM}) {
    padding: 60px 0 0 0;
    border: 0;
  }
`;
